import React from 'react'
import PropTypes from 'prop-types'
import { Badge } from 'reactstrap'
import { useTranslation } from 'react-i18next'

const ProjectArchivedBadge = ({ archived }) => {
    const { t } = useTranslation()
    return (
        <div>
            {archived && <Badge color="danger m-start-1 text-muted ">{t('Archived')}</Badge>}
        </div>
    )
}

ProjectArchivedBadge.propTypes = {
    archived: PropTypes.bool.isRequired
}

export default ProjectArchivedBadge
